export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg mb-4">久久影视</h4>
            <p className="text-sm text-white/60 leading-relaxed">
              热门电视剧全集免费在线观看平台，国产剧韩剧全集一网打尽，高清秒播不卡顿，全网剧迷的首选追剧站。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-4 text-white/80">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}>首页</a>
              <a href="#ranking" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}>热播榜单</a>
              <a href="#index" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}>专题合集</a>
              <a href="#faq" className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }}>常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-4 text-white/80">内容分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors">国产剧全集</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors">韩剧全集在线</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors">热门电视剧</span>
              <span className="text-sm text-white/50 cursor-pointer hover:text-primary-400 transition-colors">最新完结剧集</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm mb-4 text-white/80">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              久久影视与多家优质影视内容方保持密切合作，持续为广大剧迷带来最新、最全的电视剧全集在线观看资源。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; 2024 久久影视 - 电视剧全集免费在线观看平台
          </p>
          <div className="flex items-center gap-5">
            <span className="text-sm text-white/40 cursor-pointer hover:text-primary-400 transition-colors">用户协议</span>
            <span className="text-sm text-white/40 cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-sm text-white/40 cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}